import { makeAutoObservable } from "mobx";
import { appStore } from "src/appStore";
import { ZExtNotification, zExtNotification } from "src/types/ZExtNotification";
import { ZUid } from "src/types/zUid";
import { rest } from "./rest";
import { apiPushUrl } from "./apiUrl";
import { onError } from "./onError";
import {
  StompConnection,
  StompStatus,
  startStompConnection,
} from "./stompConnection";

export type ConnectionStatus = StompStatus;

let connection: StompConnection | null = null;

// НЕ ИСПОЛЬЗУЕТСЯ
// export interface UnreadInfo {
//   count: number;
//   lastReadtime: string;
//   type: string;
// }

export const notificationsStore = makeAutoObservable({
  status: "none" as ConnectionStatus,
  setStatus(newStatus: ConnectionStatus) {
    this.status = newStatus;
  },

  unreaded: [] as ZExtNotification[],
  setUnreaded(list: ZExtNotification[]) {
    this.unreaded = list;
  },
  get unreadedCount(): number {
    return this.unreaded.length;
  },

  notificationsLoading: false,
  setNotificationsLoading(value: boolean) {
    this.notificationsLoading = value;
  },
  async updateNotifications() {
    try {
      await this.saveReaded();
      this.clearReaded();
      this.setNotificationsLoading(true);
      const resp = await rest.get(apiPushUrl("/push"), {
        params: { status: "UNREAD" },
      });
      this.setUnreaded(zExtNotification.array().parse(resp.data));
    } catch (e) {
      onError(e);
    } finally {
      this.setNotificationsLoading(false);
    }
  },

  init() {
    this.updateNotifications();

    connection?.stop();
    connection = startStompConnection({
      subscribe: (client) => {
        try {
          const userId = appStore.userInfo.id;
          client.subscribe(`/messages/${userId}`, () => {
            this.updateNotifications();
          });
        } catch (e) {
          onError(e);
        }
      },
      // Уведомление, пришедшее, пока сокета не было, само уже не придёт
      resync: () => this.updateNotifications(),
      onStatus: (status) => this.setStatus(status),
      onError,
    });
  },
  clear() {
    connection?.stop();
    connection = null;
    this.setStatus("none");
    this.setUnreaded([]);
  },
  toReaded: new Set<ZUid>(),
  clearReaded() {
    this.toReaded.clear();
  },
  addReaded(msg: ZExtNotification) {
    this.toReaded.add(msg.id);
  },
  addReadedAll() {
    this.unreaded.forEach((it) => this.addReaded(it));
  },
  get isAllReaded(): boolean {
    return !this.unreaded.find(({ id }) => !this.toReaded.has(id));
  },
  // Нужно отлавливать catch
  async saveReaded() {
    const ids = Array.from(this.toReaded);
    if (ids.length > 0) {
      await rest.put(apiPushUrl("/push"), ids);
      this.setUnreaded(
        this.unreaded.filter(({ id }) => !this.toReaded.has(id)),
      );
      this.clearReaded();
    }
  },
});
